import { ReactElement } from "react";
import { Chip, Typography } from "@mui/material";
import { Sparklines, SparklinesLine } from "react-sparklines";
import CardBase from "../../../components/widgets/cardBase";
import { IDetailProps } from "../../../types";


const styles = {
  diffPositive: {
    fontWeight: "bold",
    color: "whitesmoke",
    background: "#11c26d"
  },
  diffNegative: {
    fontWeight: "bold",
    color: "whitesmoke",
    background: "#ff4c52"
  },
};

interface IComponentAProps {
  title: string;
  value: number;
  diff: number;
  points: number[];
  detail: IDetailProps | undefined | null;
}

const ComponentA = ({ value, diff, points, title, detail }: IComponentAProps): ReactElement => {

  return (
    <CardBase title={title} detail={detail}>
      <div className="display-flex-column justify-content-space-around" style={{ height: 140 }}>

        <Typography variant="h4" className="m-1 flex-grow-0" >
          {value}
        </Typography>

        <div className="m-1 flex-grow-0">
          <Chip size="small" label={diff} sx={ diff >= 0 ? styles.diffPositive : styles.diffNegative }/>
        </div>

        <div className="w-100" style={{ height: "25" }}>
          <Sparklines data={points} limit={5} width={100} height={25}  >
            <SparklinesLine color="#11c26d" />
          </Sparklines>
        </div>

      </div>
    </CardBase>
  );
};

export default ComponentA;
